'use client';

import { StepNumber } from '../step-number/step-number';
import { RadioGroup } from '@shared/shared-shadcn-ui';
import { FormRadioButton } from '../form-radio-button/form-radio-button';
import { FormButton } from '../../../../../../../_libs/components/components';
import { useState } from 'react';
import ArrowRightIcon from '../../../../../../../../../public/svg/arrow-right.svg';

type Properties = {
  onContinue: () => void;
};

const WoundResultOfStep = ({ onContinue }: Properties) => {
  const [selectedWoundResult, setSelectedWoundResult] = useState<string | null>(
    null,
  );

  return (
    <div>
      <div className="flex gap-x-6 lg:ml-[50px] xl:ml-[150px] items-center bg-white rounded-t-[16px] py-10">
        <StepNumber number={2} />
        <h4 className="text-[30px] lg:text-[44px] font-bold text-ogn-blue leading-normal">
          My wound is a result of a:
        </h4>
      </div>
      <div className="mt-10 pl-[74px] lg:pl-0">
        <RadioGroup
          value={selectedWoundResult}
          onValueChange={(value) => setSelectedWoundResult(value)}
          className="flex justify-center"
        >
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            <FormRadioButton label="Chronic medical condition" value="1" />
            <FormRadioButton label="Recent surgical procedure" value="2" />
            <FormRadioButton label="Injury" value="3" />
            <FormRadioButton
              label={
                <>
                  Dermatological condition <br /> or procedure
                </>
              }
              value="4"
            />
            <FormRadioButton
              className="-mt-7"
              label="Another reason"
              value="5"
            />
          </div>
        </RadioGroup>
      </div>
      <FormButton
        className="mx-auto w-[300px] my-16 font-roboto-condensed"
        onClick={onContinue}
        isDisabled={!selectedWoundResult}
      >
        Next
        <ArrowRightIcon className="w-6 h-6" />
      </FormButton>
    </div>
  );
};

export { WoundResultOfStep };
